import { useTranslations } from '~i18n/hooks';

export const usePromocodeErrorConfig = (): Record<string, string> => {
	const t = useTranslations('Promocode');

	return {
		NotApplicable: t('promocodeErrorNotApplicable'),
		Expired: t('promocodeErrorExpired'),
		Consumed: t('promocodeErrorConsumed'),
		AlreadyAssigned: t('promocodeErrorConsumed'),
		NotFound: t('promocodeErrorNotFound'),
	};
};
